(function($) {
	var $hero = $('.hero-profile');
	var $share = $('.profile-share-toggle');
	$share.click(function() {
		$hero.add('.profile-btns').toggleClass('sharing');
		if ($hero.hasClass('sharing')) {
			$share.text('Close');
		} else {
			$share.text('Share Profile');
		}
	});


	function new_map($el) {
		var $markers = $el.find('.marker');

		var map = new google.maps.Map($el[0], {
			zoom: 12,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});
		map.markers = [];

		$markers.each(function() {
			add_marker($(this), map);
		});

		center_map(map);

		return map;
	}


	function add_marker($marker, map) {
		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		var marker = new google.maps.Marker({
			position: latlng,
			map: map
		});

		map.markers.push(marker);


		if ($marker.html()) {
			var startForm = '<form id="start-form" style="display:none" action="https://maps.google.com/maps" method="get" target="_blank">' +
				'<input type="hidden" name="daddr" value="' + latlng.lat() + ',' + latlng.lng() + '"/>' +
				'<div><label for="saddr" class="profile-map-dir-label">Start Address</label>' +
				'<div class="profile-map-dir">' +
				'<div class="profile-map-dir-input"><input type="text" class="form-control input-sm" name="saddr" id="saddr"></div>' +
				'<div class="profile-map-dir-btn"><button class="btn btn-primary btn-sm">Get Directions</button></div>' +
				'</div></div>' +
			'</form>';

			var endForm = '<form id="end-form" style="display:none" action="https://maps.google.com/maps" method="get" target="_blank">'+
				'<input type="hidden" name="saddr" value="' + latlng.lat() + ',' + latlng.lng() + '"/>' +
				'<div><label for="daddr" class="profile-map-dir-label">End Address</label>' +
				'<div class="profile-map-dir">' +
				'<div class="profile-map-dir-input"><input type="text" class="form-control input-sm" name="daddr" id="daddr"></div>' +
				'<div class="profile-map-dir-btn"><button class="btn btn-primary btn-sm">Get Directions</button></div>' +
				'</div></div>' +
			'</form>';


			var $toHereLink = $('<a>To Here</a>');
			$toHereLink.click(function(e) {
				e.preventDefault();
				$('.profile-map-dir-active').removeClass('profile-map-dir-active');
				$(this).addClass('profile-map-dir-active');

				$('#end-form').hide();
				$('#start-form').show();
			});

			var $fromHereLink = $('<a>From Here</a>');
			$fromHereLink.click(function(e) {
				e.preventDefault();
				$('.profile-map-dir-active').removeClass('profile-map-dir-active');
				$(this).addClass('profile-map-dir-active');

				$('#end-form').show();
				$('#start-form').hide();
			});

			// Append directions HTML
			var $nav = $('<div>Get Directions: </div>');
			$nav.append($toHereLink, ' or ', $fromHereLink);

			$marker.append($nav);
			$marker.append(endForm);
			$marker.append(startForm);
			

			var infowindow = new google.maps.InfoWindow({
				content: $marker[0]
			});
			infowindow.open(map, marker);

			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open(map, marker);
			});
		}
	}


	function center_map(map) {
		var bounds = new google.maps.LatLngBounds();
		$.each(map.markers, function(i, marker) {
			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
			bounds.extend(latlng);
		});

		if (map.markers.length === 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(12);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}


	$(document).ready(function() {
		$('.profile-map').each(function() {
			// Create map
			new_map($(this));
		});
	});
		
})(jQuery);